/**
 * Plan metadata used across the booking & dashboard flows.
 *
 * Kept in one tiny file so we don't repeat the nested ternaries
 * (`plan === 'best-pals' ? 4 : plan === 'my-pal' ? 3 : 2`) everywhere.
 */

const PLAN_METADATA = {
  'lets-be-pals': { label: "Let's Be Pals", maxPickups: 1, maxPackages: 3 },
  'your-pal': { label: 'Your Pal', maxPickups: 2, maxPackages: 10 },
  'my-pal': { label: 'My Pal', maxPickups: 3, maxPackages: 15 },
  'best-pals': { label: 'Best Pals', maxPickups: 4, maxPackages: 20 },
};

export const getPlanLabel = (planType) =>
  PLAN_METADATA[planType]?.label || PLAN_METADATA['lets-be-pals'].label;

export const getPlanMaxPickups = (planType) =>
  PLAN_METADATA[planType]?.maxPickups ?? PLAN_METADATA['lets-be-pals'].maxPickups;

export const getPlanMaxPackages = (planType) =>
  PLAN_METADATA[planType]?.maxPackages ?? PLAN_METADATA['lets-be-pals'].maxPackages;
